export const getJson = (data: object) => {
  const x = window.open()
  x?.document.open()
  x?.document.write("<html><body><pre>" + JSON.stringify(data, null, 3) + "</pre></body></html>")
  x?.document.close()
}
